import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue';
import { SpaPageRenderedEventKey, SpaAwaitingPageEventKey, router } from '@/core/router';
import bus from '@/core/bus';
import { QueryKeys } from '@/shared/config/route-query.config';
import { useRoute } from 'vue-router';
import { applyFacets } from '@/core/browser/route-query.composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageRenderTransitionHandler',
  props: {
    isChangingPage: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    isChangingPage: boolean;
}



const route = useRoute();
const silentUpdate = ref<boolean>(false);
let silentUpdateTimer:number;

bus.on(SpaAwaitingPageEventKey, () => {
    silentUpdateTimer && clearTimeout(silentUpdateTimer);
    silentUpdate.value = !!route.query[QueryKeys.SpaSilentUpdate];
});

bus.on(SpaPageRenderedEventKey, ({ initialPageLoad }) => {
    const maybeFullQuery = initialPageLoad ? route.query : {};
    const pageAnimateInTiming = 200;
    silentUpdateTimer = setTimeout(() => {
        silentUpdate.value = false;
    }, pageAnimateInTiming);
    applyFacets(router, route, { ...maybeFullQuery, [QueryKeys.SpaSilentUpdate]: undefined });
});

const transitionToPage = computed<boolean>(() => props.isChangingPage && !silentUpdate.value);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page", { 'page-transition': _unref(transitionToPage) }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})